module.exports = __webpack_public_path__ + "img/phone-20211216.8ef61a5d.png";